import { getPrecisedNumber } from '@/helpers';


export default function getTxAmount(
  value: string | number,
  precision = 0,
  viewPrecision = 12,
) {
  const devider = 10 ** precision;
  const amount = +value / devider;

  return getPrecisedNumber(amount, viewPrecision);
}
